import sanitizeHTML from '../../../utils/sanitiseHTML';

const About = ({ aboutSection }) => {
  return (
    <div className="section__about">
      <div className="section__about__container">
        <h2>{aboutSection?.title}</h2>
        <div
          className="subtitle_1"
          dangerouslySetInnerHTML={{ __html: sanitizeHTML(aboutSection?.subtitle) }}
        />
        <div className="section__about__img" data-bg={aboutSection?.image?.sourceUrl} />
        <div className="section__about__vl">
          <div
            className="section__about__vl__text subtitle_2"
            dangerouslySetInnerHTML={{ __html: sanitizeHTML(aboutSection?.description) }}
          />
        </div>
        <div className="section__about__virtual-link">
          <div
            dangerouslySetInnerHTML={{
              __html: sanitizeHTML(aboutSection?.linkDescription),
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default About;
